export default __webpack_public_path__ + "static/media/cages.761cacc1.png";